/**
 * Correctly appends queries to a url using the enviornment
 */
export default (url: string, ...queries: [string, string][]): string => {
  const query: string = queries.map(([k, v]) => `${k}=${v}`).join("&");

  return `${url}?${query}`;
};
